import { render, staticRenderFns } from "./guide-verification-code.vue?vue&type=template&id=1f273426"
import script from "./guide-verification-code.vue?vue&type=script&lang=js"
export * from "./guide-verification-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports